import React, { useEffect, useMemo, useState } from "react";
import EditorDashboardWrapper from "../../../layout/wrapper/EditorDashboardWrapper";
import styles from "../../../styles/pages/user/editordashboard/editor-search-result.module.scss";
import searchImage1 from "../../../public/assets/images/searchresult_banner1.jpg";

import { Box } from "@mui/system";
import { List, ListItem, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import SearchIcons from "../../../public/assets/images/search-glass.svg";
import { useInfiniteQuery } from "react-query";
import { searchDataCallEditor } from "../../../api/functions/editorDashboard.api";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { useDebounce } from "use-debounce";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  concatHostAndImagePath,
  getUtcDate,
  getUtcTime,
} from "../../../lib/functions/utils.lib";
import ApiLoader from "../../../components/Loaders/ApiLoader";
import VideoPageFullModal from "../../../components/VideoPages/pages/VideoPageFullModal";
import WatchVideoModal from "../../../components/VideoPages/pages/WatchVideoModal";

const searchResultContent = [
  {
    image: `${searchImage1}`,
    id: "20135",
    date: "September 26, 2019 at 05:45:23 AM UTC",
    name: "John Smith",
    email: "johnsmith@gmail.com",
    acquisitor: "Theodoulke Tadris",
    acquisitordetails: "(Partner)",
    status: "pendingUpdate",
    statusText: (
      <>
        Metadata Revised & Pending Update <br />
        Since January 22, 2023 at 07:56 PM UTC.
      </>
    ),
    currenWorking: false,
  },
  {
    image: `${searchImage1}`,
    id: "20135",
    date: "September 26, 2019 at 05:45:23 AM UTC",
    name: "John Smith",
    email: "johnsmith@gmail.com",
    acquisitor: "Theodoulke Tadris",
    acquisitordetails: "(Partner)",
    status: "pendingRevision",
    statusText: (
      <>
        Title Pending Revision <br />
        Since January 22, 2023 at 07:56 PM UTC.
      </>
    ),
    currenWorking: false,
  },
  {
    image: `${searchImage1}`,
    id: "5045",
    date: "September 26, 2019 at 05:45:23 AM UTC",
    name: "John Smith",
    email: "johnsmith@gmail.com",
    acquisitor: "Theodoulke Tadris",
    acquisitordetails: "(Partner)",
    status: "compeleteStatus",
    statusText: (
      <>
        Video Pending Publication <br /> Since September 26, 2019 at 05:45:23 AM
        UTC.
      </>
    ),
    currenWorking: true,
  },
  {
    image: `${searchImage1}`,
    id: "5045",
    date: "September 26, 2019 at 05:45:23 AM UTC",
    name: "John Smith",
    email: "johnsmith@gmail.com",
    acquisitor: "Theodoulke Tadris",
    acquisitordetails: "(Partner)",
    status: "compeleteStatus",
    statusText: <>Video Published on September 26, 2019 at 05:45:23 AM UTC.</>,
    currenWorking: false,
  },
  {
    image: `${searchImage1}`,
    id: "5045",
    date: "September 26, 2019 at 05:45:23 AM UTC",
    name: "John Smith",
    email: "johnsmith@gmail.com",
    acquisitor: "Theodoulke Tadris",
    acquisitordetails: "(Partner)",
    status: "compeleteStatus",
    statusText: (
      <>
        Video Pending Publication <br />
        Since September 26, 2019 at 05:45:23 AM UTC.
      </>
    ),
    currenWorking: false,
  },
  {
    image: `${searchImage1}`,
    id: "5045",
    date: "September 26, 2019 at 05:45:23 AM UTC",
    name: "John Smith",
    email: "johnsmith@gmail.com",
    acquisitor: "Theodoulke Tadris",
    acquisitordetails: "(Partner)",
    status: "compeleteStatus",
    statusText: (
      <>
        Video Pending Publication <br /> Since September 26, 2019 at 05:45:23 AM
        UTC.
      </>
    ),
    currenWorking: true,
  },
];

function EditorSearchResult() {
  const [searchResult, searchNoResult] = useState(true);
  const { query, check } = useAppSelector((s) => s.editorSearchQuerySlice);
  console.warn("query", query);
  const [previousData, setPreviousData] = useState(null);
  const [searchData, setSearchData] = useState("");
  const [value] = useDebounce(query, 600);

  const { data, fetchNextPage, hasNextPage, refetch, isLoading, isRefetching } =
    useInfiniteQuery({
      queryKey: ["search", value],
      queryFn: ({ pageParam = 1 }) => {
        // console.warn(pageParam, "pageParam");
        if (query.length !== 0) {
          return searchDataCallEditor(value, pageParam);
        }
      },
      keepPreviousData: true,

      enabled: !!query,

      getNextPageParam: (lastPage, allPages) => {
        if (
          allPages[allPages.length - 1 || 0]?.current_page <
          allPages[0]?.last_page
        ) {
          return allPages[allPages.length - 1 || 0]?.current_page + 1;
        } else {
          return undefined;
        }
      },
    });
  // console.warn("data", data);
  const searchResultData = useMemo(() => {
    var dat = { data: [] };
    data?.pages?.forEach((item) => {
      dat = { ...item, data: [...dat?.data, ...item.data] };
    });
    return dat;
  }, [data]);

  console.warn("searchResultData", searchResultData);

  useEffect(() => {
    if (searchResultData) {
      setSearchData(query);
    }
  }, [searchResultData]);

  function videoStatus(item) {
    if (
      item?.video_meta?.revision_request === 2 &&
      item?.video_extra?.confirm_update === 0
    ) {
      return "Metadata Revised & Pending Update";
    } else if (item?.video_meta?.revision_request === 1) {
      return "Title Pending Revision";
    } else if (item?.published === 0) {
      return "Video Pending Publication";
    } else {
      return null;
    }
  }

  function videoDate(item) {
    if (
      item?.video_meta?.revision_request === 2 &&
      item?.video_extra?.confirm_update === 0
    ) {
      return `Since ${getUtcDate(
        item?.video_meta?.revision_requested_at
      )}${getUtcTime(item?.video_meta?.revision_requested_at)}`;
    } else if (item?.video_meta?.revision_request === 1) {
      return `Since ${getUtcDate(
        item?.video_meta?.revision_requested_at
      )}${getUtcTime(item?.video_meta?.revision_requested_at)}`;
    } else if (item?.published === 0) {
      return item?.video_meta?.copywrite_completed_at
        ? `Since ${getUtcDate(
            item?.video_meta?.copywrite_completed_at
          )}${getUtcTime(item?.video_meta?.copywrite_completed_at)}`
        : null;
    } else if (item?.publshed === 1) {
      return item?.published_at
        ? `Video Published on ${getUtcDate(item?.published_at)}${getUtcTime(
            item?.published_at
          )}`
        : null;
    } else {
      return null;
    }
  }

  function videoColorType(item) {
    if (
      item?.video_meta?.revision_request === 2 &&
      item?.video_extra?.confirm_update === 0
    ) {
      return `${styles.pedingupdate} ${styles.updateStatusTrack}`;
    } else if (item?.video_meta?.revision_request === 1) {
      return `${styles.pedingrevision} ${styles.updateStatusTrack}`;
    } else if (item?.publshed === 1) {
      return `${styles.completestatus} ${styles.updateStatusTrack}`;
    } else if (item?.published === 0) {
      return `${styles.completestatus} ${styles.updateStatusTrack}`;
    } else {
      return null;
    }
  }

  const [openModal, setOpenModal] = useState(false);
  const [openModalTwo, setOpenModalTwo] = useState(false);
  const [id, setId] = useState();

  const onOpen = (id) => {
    setId(id);
    setOpenModal(true);
  };
  const onClose = () => {
    setId();
    setOpenModal(false);
  };
  const onOpenTwo = (id) => {
    setId(id);
    setOpenModalTwo(true);
  };
  const onCloseTwo = () => {
    setId();
    setOpenModalTwo(false);
  };

  return (
    <>
      {isLoading ? (
        <ApiLoader loading={isLoading || isRefetching} />
      ) : (
        <EditorDashboardWrapper>
          {searchResultData?.data?.length > 0 ? (
            <Box className={styles.search_result_wrapper}>
              <Box className={styles.search_result_outers}>
                <Box className={styles.searchrslt_name}>
                  <Typography variant="h5" className={styles.result_h5}>
                    Search results for {searchData}
                  </Typography>
                  <Typography
                    variant="caption"
                    className={styles.search_result_number}
                  >
                    {searchResultData?.total < 2
                      ? `${searchResultData?.total} result`
                      : `${searchResultData?.total} results`}
                  </Typography>
                </Box>
                <PerfectScrollbar className={styles.searchresultscrolls}>
                  <Box className={styles.search_result_all}>
                    <InfiniteScroll
                      dataLength={searchResultData?.data?.length}
                      next={fetchNextPage}
                      height={`calc(100vh - 260px)`}
                      hasMore={hasNextPage}
                      loader={<h4>Loading...</h4>}
                    >
                      {searchResultData?.data?.map((item, index) => (
                        <>
                          <Box className={styles.search_result_in} key={index}>
                            <Box className={`section${index}`}></Box>
                            <Box
                              className={styles.main_img}
                              onClick={() => onOpenTwo(item?.vsid)}
                            >
                              <img
                                src={concatHostAndImagePath(item?.thumbnail)}
                                alt=""
                              />
                            </Box>
                            <Box className={styles.search_result_in_rttt}>
                              <Box className={styles.search_details_list}>
                                <List>
                                  <ListItem>
                                    <Box
                                      className={styles.search_inner_boxes}
                                      onClick={() => onOpen(item?.vsid)}
                                    >
                                      <strong>VSID:</strong>
                                      {item?.vsid}
                                    </Box>
                                  </ListItem>

                                  <ListItem>
                                    <Box className={styles.search_inner_boxes}>
                                      <strong>Submission Date:</strong>
                                      {`${getUtcDate(
                                        item?.created_at
                                      )}${getUtcTime(item?.created_at)}`}
                                    </Box>
                                  </ListItem>

                                  <ListItem>
                                    <Box
                                      className={`${styles.search_inner_boxes} ${styles.submitter}`}
                                    >
                                      <strong>Submitter Name:</strong>
                                      {item?.first_name || item?.last_name
                                        ? `${item?.first_name} ${item?.last_name}`
                                        : "N/A"}
                                    </Box>
                                  </ListItem>

                                  <ListItem>
                                    <Box className={styles.search_inner_boxes}>
                                      <strong>Email Address:</strong>
                                      <Link to={`mailto: ${item?.email}`}>
                                        {item?.email}
                                      </Link>
                                    </Box>
                                  </ListItem>

                                  <ListItem>
                                    <Box className={styles.search_inner_boxes}>
                                      <strong>Acquisitor:</strong>
                                      {`${item?.user?.name} ${item?.user?.last_name}`}
                                      <Typography
                                        variant="caption"
                                        className={styles.details_aqstr}
                                      >
                                        {item?.user?.role?.display_name
                                          ? `(${item?.user?.role?.display_name})`
                                          : ""}
                                      </Typography>
                                    </Box>
                                  </ListItem>
                                </List>
                              </Box>
                              {videoStatus(item) && videoDate(item) ? (
                                <Box
                                  /* className={
                                    item?.status === "pendingUpdate"
                                      ? `${styles.pedingupdate} ${styles.updateStatusTrack}`
                                      : item?.status === "pendingRevision"
                                      ? `${styles.pedingrevision} ${styles.updateStatusTrack}`
                                      : `${styles.completestatus} ${styles.updateStatusTrack}`
                                  } */
                                  className={videoColorType(item)}
                                >
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {videoStatus(item)}
                                  </Typography>
                                  <Typography variant="body2">
                                    {videoDate(item)}
                                  </Typography>
                                </Box>
                              ) : (
                                ""
                              )}
                            </Box>
                            {item?.currenWorking ? (
                              <Box className={styles.current_work_process}>
                                <Typography variant="body1">
                                  Another colleague is currently working on this
                                  video.
                                </Typography>
                              </Box>
                            ) : (
                              ""
                            )}
                          </Box>
                        </>
                      ))}
                    </InfiniteScroll>
                  </Box>
                </PerfectScrollbar>
              </Box>
            </Box>
          ) : (
            <Box
              className={`${styles.search_result_wrapper} ${styles.noresult}`}
            >
              <Box className={styles.search_result_outers}>
                <i className={styles.icon_sec}>
                  <img src={SearchIcons} alt="" />
                </i>
                <Typography variant="body1">
                  We couldn’t find any matching videos for{" "}
                  <strong>{query}</strong>
                </Typography>
              </Box>
            </Box>
          )}
          <VideoPageFullModal
            onClose={onClose}
            open={openModal}
            id={id}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="videoPageModal"
          />
          <WatchVideoModal
            onClose={onCloseTwo}
            open={openModalTwo}
            id={id}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="videoPageModal"
          />
        </EditorDashboardWrapper>
      )}
    </>
  );
}

export default EditorSearchResult;
